import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom'; // 1. Adicione useLocation

export default function AdminLayout() {
  const location = useLocation();

  // 2. Verifica se a URL atual contém "dashboard" ou é a raiz (ajuste conforme suas rotas)
  // Se sua rota for apenas "/", adicione: || location.pathname === '/'
  const isDashboard =
    location.pathname.includes('dashboard') || location.pathname === '/';

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-800 text-white flex flex-col h-screen sticky top-0">
        <div className="p-4 font-bold">Painel Admin</div>
        <nav className="flex flex-col space-y-2">
          <NavLink
            to="/admin/dashboard"
            className="px-4 py-2 hover:bg-gray-700"
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/admin/assinaturas"
            className="px-4 py-2 hover:bg-gray-700"
          >
            Assinaturas
          </NavLink>
          <NavLink
            to="/admin/pagamentos"
            className="px-4 py-2 hover:bg-gray-700"
          >
            Pagamentos
          </NavLink>
          <NavLink to="/admin/planos" className="px-4 py-2 hover:bg-gray-700">
            Planos
          </NavLink>
          <NavLink
            to="/admin/notificacoes"
            className="px-4 py-2 hover:bg-gray-700"
          >
            Notificações
          </NavLink>
        </nav>
      </aside>

      {/* Conteúdo */}
      {/* 3. Lógica condicional para remover margens APENAS na dashboard */}
      <main
        className={`flex-1 ${
          isDashboard
            ? 'p-0 bg-[#071426] overflow-hidden' // Estilo SÓ para Dashboard (sem margem, fundo escuro)
            : 'p-6 bg-gray-100 overflow-auto' // Estilo para as outras páginas (com margem, fundo cinza)
        }`}
      >
        <Outlet />
      </main>
    </div>
  );
}
